import {
  WIX_CHALLENGES,
  WIX_BOOKINGS,
  WIX_EVENTS,
  WIX_FORMS,
  WIX_GROUPS,
  PRICING_PLANS,
  WIX_BLOG,
  WIX_VIDEO,
  MEMBERS_AREA,
  WIX_RESTAURANTS_ORDERS_NEW,
  WIX_CHAT,
  WIX_SITE_SEARCH,
  WIX_FILE_SHARE,
  WIX_PORTFOLIO,
  WIX_FAQ,
  RESTAURANTS,
  WIX_DONATIONS,
  WIX_LOYALTY_PROGRAM,
  WIX_REFERRAL_PROGRAM,
  WIX_RESTAURANTS_MENUS_NEW,
  WIX_RESTAURANTS_TABLE_RESERVATIONS,
  INSTAGRAM_FEED_NEW,
  WIX_AI_CHAT_ASSISTANT,
  WIX_SERVICES,
} from '@wix/app-definition-ids';
import experiment from 'experiment';
import { tpaUtils } from '#packages/util';

export const APP_MANAGER_ORIGIN = 'app-manager';

export const APP_MANAGER_APPS_LIST = [
  tpaUtils.getStoresAppDefId(),
  WIX_BOOKINGS,
  experiment.isOpen('se_includeWixServicesInMyBusiness') ? WIX_SERVICES : null,
  WIX_BLOG,
  WIX_AI_CHAT_ASSISTANT,
  WIX_RESTAURANTS_MENUS_NEW,
  experiment.isOpen('se_includeRestaurantsOrdersInMyBusinessPanel')
    ? WIX_RESTAURANTS_ORDERS_NEW
    : null,
  WIX_RESTAURANTS_TABLE_RESERVATIONS,
  WIX_EVENTS,
  PRICING_PLANS,
  WIX_GROUPS,
  WIX_FORMS,
  WIX_CHALLENGES,
  MEMBERS_AREA,
  WIX_VIDEO,
  WIX_CHAT,
  WIX_SITE_SEARCH,
  WIX_PORTFOLIO,
  WIX_FILE_SHARE,
  WIX_FAQ,
  WIX_LOYALTY_PROGRAM,
  WIX_REFERRAL_PROGRAM,
  experiment.isOpen('se_includeDonationsInMyBusinessPanel')
    ? WIX_DONATIONS
    : null,
  experiment.isOpen('se_includeRestaurantsInMyBusinessPanel')
    ? RESTAURANTS
    : null,
  experiment.isOpen('se_DisplayNewInstagramAppInAppManager')
    ? INSTAGRAM_FEED_NEW
    : null,
].filter(Boolean);

export const TRANSLATIONS = { PANEL_TITLE: 'App_Manager_Panel_Title' };
